import {inject, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AuthenticationService} from './authentication.service';
import {LicenzeService} from './licenze.service';
import {constants} from '../_helpers/constants';

/** Feature 159: apertura del pannello della chat AI, condivisa tra il bottone nell'header (presente in
 * ogni pagina) e il pannello unico in `app.component.html`. */
@Injectable({providedIn: 'root'})
export class AiChatPanelService {
  private readonly apertoSubject = new BehaviorSubject<boolean>(false);
  readonly aperto$ = this.apertoSubject.asObservable();
  private readonly authService = inject(AuthenticationService);
  private readonly licenzeService = inject(LicenzeService);

  get aperto(): boolean {
    return this.apertoSubject.value;
  }

  /** Operatore autenticato, licenza `AI-BASE-CHAT` sull'organizzazione corrente e ruolo `CHAT`. */
  get disponibile(): boolean {
    return !!this.authService.currentUserValue?.jwtToken
      && this.licenzeService.checkPermesso(constants.MOD_AI_BASE_CHAT)
      && this.authService.isInRole(constants.ROLE_CHAT);
  }

  apri() {
    if (this.disponibile) this.apertoSubject.next(true);
  }

  chiudi() {
    this.apertoSubject.next(false);
  }

  alterna() {
    if (this.aperto) this.chiudi(); else this.apri();
  }
}
